export const validation = (formData) => {
  const errors = {};

  const isEmpty = (val) => val === undefined || val === null || val === '';
  const isNumber = (val) => !isNaN(val);
  const isPositive = (val) => parseFloat(val) > 0;

  // Role ID validation
  if (isEmpty(formData.roleId) || formData.roleId === 0) {
    errors.roleId = 'User type is required';
  }

  // Basic required fields
  if (isEmpty(formData.offerType)) errors.offerType = 'Offer type is required';
  if (isEmpty(formData.deliveryRequestType))
    errors.deliveryRequestType = 'Delivery request type is required';
  if (isEmpty(formData.senderType))
    errors.senderType = 'Sender type is required';
  if (isEmpty(formData.region)) errors.region = 'Country is required';

  // Offer name validation

  const offerName = formData.offerName;

  // Allowed characters: letters, numbers, spaces, - _ % $ , . & – ₹ and currency symbols
  const allowedCharRegex = /^[\p{L}\p{N}\s\-_%$,.&\u2013\u20B9\p{Sc}]+$/u;
  const hasLetterOrNumber = /[\p{L}\p{N}]/u;

  // This regex flags '%10' but allows '% 10' (space between % and number)
  const invalidPercentPlacement = /(^|\s)%(\d)/;

  // Check for repeated consecutive words (case-insensitive)
  function hasRepeatedWords(str) {
    const words = str.toLowerCase().trim().split(/\s+/);
    for (let i = 1; i < words.length; i++) {
      if (words[i] === words[i - 1]) {
        return true;
      }
    }
    return false;
  }

  if (isEmpty(offerName)) {
    errors.offerName = 'Offer name is required';
  } else if (offerName.length < 3) {
    errors.offerName = 'Offer name must be at least 3 characters long';
  } else if (offerName.length > 50) {
    errors.offerName = 'Offer name must not be more than 50 characters long';
  } else if (/^\d+$/.test(offerName)) {
    errors.offerName = 'Offer name cannot be numbers only';
  } else if (
    /([A-Z]{2,})/.test(offerName) &&
    offerName === offerName.toUpperCase()
  ) {
    errors.offerName = 'Offer name should not be ALL CAPS';
  } else if (!allowedCharRegex.test(offerName)) {
    errors.offerName =
      'Only letters, numbers, currency symbols, spaces, and - _ % $ , . & – ₹ are allowed';
  } else if (!hasLetterOrNumber.test(offerName)) {
    errors.offerName = 'Offer name must contain at least one letter or number';
  } else if (invalidPercentPlacement.test(offerName)) {
    errors.offerName = 'The % symbol must come after a number (e.g., 10%)';
  } else if (hasRepeatedWords(offerName)) {
    errors.offerName = 'Offer name should not contain repeated words';
  }

  // Discount Type validation
  if (isEmpty(formData.discountType)) {
    errors.discountType = 'Discount type is required';
  }

  if (formData.discountType === 'PERCENTAGE_DISCOUNT') {
    if (isEmpty(formData.percentageDiscount)) {
      errors.percentageDiscount = 'Percentage discount is required';
    } else if (parseFloat(formData.percentageDiscount) > 100) {
      errors.percentageDiscount = 'Percentage discount cannot exceed 100';
    }
  }

  const value = formData.minimumOrderAmount;

  if (value === '' || value === null || value === undefined) {
    // no error if the field is optional and blank
  } else if (!/^\d+(\.\d+)?$/.test(value)) {
    errors.minimumOrderAmount = 'Minimum Order Amount must be a number';
  } else if (/e|E/.test(value.toString())) {
    errors.minimumOrderAmount =
      'Minimum Order Amount should not be in scientific notation';
  } else if (Number(value) > 99999) {
    errors.minimumOrderAmount =
      'Minimum Order Amount should not be more than 5 digits (99999)';
  }

  const countOfUsageLimitsVal = formData.countOfUsageLimits;

  if (
    countOfUsageLimitsVal === '' ||
    countOfUsageLimitsVal === null ||
    countOfUsageLimitsVal === undefined
  ) {
    // no error if the field is optional and blank
  } else if (!/^\d+(\.\d+)?$/.test(countOfUsageLimitsVal)) {
    errors.countOfUsageLimitsVal =
      'Count of usage limit must be a valid number';
  } else if (/e|E/.test(countOfUsageLimitsVal.toString())) {
    errors.countOfUsageLimitsVal =
      'Count of usage limit should not be in scientific notation';
  } else if (Number(countOfUsageLimitsVal) > 99999) {
    errors.countOfUsageLimitsVal =
      'Count of usage limit should not be more than 5 digits (99999)';
  }

  // Role-specific logic
  const isRole3 = formData.roleId === '3';

  // Reward/Discount Amounts
  if (isRole3) {
    if (
      isEmpty(formData.maxDiscountAmount) ||
      !isPositive(formData.maxDiscountAmount)
    ) {
      errors.maxDiscountAmount = 'Reward amount is required.';
    } else if (!isNumber(formData.maxDiscountAmount)) {
      errors.maxDiscountAmount = 'Reward amount must be a number';
    } else if (parseFloat(formData.maxDiscountAmount) > 99999) {
      errors.maxDiscountAmount = 'Reward amount cannot exceed 99999';
    }
  } else if (formData.discountType !== 'FREE_DELIVERY') {
    const amt = formData.discountAmount;
    if (!isNumber(amt)) {
      errors.discountAmount = 'Reward amount must be a number';
    } else if (parseFloat(amt) > 99999) {
      errors.discountAmount = 'Reward amount cannot exceed 99999';
    } else if (amt && parseFloat(amt) > 100) {
      errors.discountAmount = 'Discount percentage cannot exceed 100%';
    }
  }

  if (!isRole3) {
    const maxAmt = formData.maxDiscountAmount;
    if (isEmpty(maxAmt)) {
      errors.maxDiscountAmount = 'Max Discount Amount is required';
    } else if (!isNumber(maxAmt)) {
      errors.maxDiscountAmount = 'Max Discount Amount must be a number';
    } else if (parseFloat(maxAmt) <= 0) {
      errors.maxDiscountAmount = 'Max Discount Amount must be greater than 0';
    } else if (parseFloat(maxAmt) > 99999) {
      errors.maxDiscountAmount = 'Max Discount Amount cannot exceed 99999';
    }

    if (formData.noOfDelivery) {
      errors.noOfDelivery = null;
    }
    if (formData.deliveryDuration) {
      errors.deliveryDuration = null;
    }
  }

  // Discount Application
  if (isEmpty(formData.discountApplication)) {
    errors.discountApplication = 'Discount Application is required';
  }

  // Promotion Start Date
  if (isEmpty(formData.promotionStartDate)) {
    errors.promotionStartDate = 'Start date is required';
  } else {
    const today = new Date();
    const startDate = new Date(formData.promotionStartDate);
    today.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);
    if (startDate < today) {
      errors.promotionStartDate = 'Start date cannot be in the past';
    }
  }

  // Promotion Start Time
  if (isEmpty(formData.promotionStartTime)) {
    errors.promotionStartTime = 'Start time is required';
  } else if (!isEmpty(formData.promotionStartDate)) {
    // If start date is today, start time must not be in the past
    const today = new Date();
    const startDate = new Date(formData.promotionStartDate);
    const [startHour, startMin, startSec] = formData.promotionStartTime
      .split(':')
      .map(Number);
    if (startDate.toDateString() === today.toDateString()) {
      const now = new Date();
      const startTime = new Date();
      startTime.setHours(startHour, startMin, startSec || 0, 0);
      if (startTime < now) {
        errors.promotionStartTime =
          'Start time cannot be the current time or in the past';
      }
    }
  }

  // Promotion End Time
  if (
    !isEmpty(formData.promotionEndTime) &&
    !isEmpty(formData.promotionEndDate)
  ) {
    const endDate = new Date(formData.promotionEndDate);
    const [endHour, endMin, endSec] = formData.promotionEndTime
      .split(':')
      .map(Number);
    const today = new Date();
    if (endDate.toDateString() === today.toDateString()) {
      const now = new Date();
      const endTime = new Date();
      endTime.setHours(endHour, endMin, endSec || 0, 0);
      if (endTime < now) {
        errors.promotionEndTime = 'End time cannot be in the past';
      }
    }
    // If start and end date are the same, end time must be after start time
    if (
      !isEmpty(formData.promotionStartDate) &&
      formData.promotionStartDate === formData.promotionEndDate
    ) {
      const [startHour, startMin, startSec] = formData.promotionStartTime
        ? formData.promotionStartTime.split(':').map(Number)
        : [0, 0, 0];
      const startTime = new Date();
      startTime.setHours(startHour, startMin, startSec || 0, 0);
      const endTime = new Date();
      endTime.setHours(endHour, endMin, endSec || 0, 0);
      if (endTime <= startTime) {
        errors.promotionEndTime = 'End time must be after start time';
      }
    }
  }
  // If only start date is set (no end date), validate end time is after start time
  if (
    !isEmpty(formData.promotionEndTime) &&
    isEmpty(formData.promotionEndDate) &&
    !isEmpty(formData.promotionStartDate) &&
    !isEmpty(formData.promotionStartTime)
  ) {
    const [startHour, startMin, startSec] = formData.promotionStartTime
      .split(':')
      .map(Number);
    const [endHour, endMin, endSec] = formData.promotionEndTime
      .split(':')
      .map(Number);
    const startTime = new Date();
    startTime.setHours(startHour, startMin, startSec || 0, 0);
    const endTime = new Date();
    endTime.setHours(endHour, endMin, endSec || 0, 0);
    if (endTime <= startTime) {
      errors.promotionEndTime = 'End time must be after start time';
    }
  }

  // Usage Frequency
  if (isEmpty(formData.usageFrequency)) {
    errors.usageFrequency = 'Usage frequency is required';
  }

  // Promo Code
  const code = formData.code;
  if (isEmpty(code)) {
    errors.code = 'Code is required';
  } else if (/\s/.test(code)) {
    errors.code = 'Code cannot contain spaces';
  } else if (!/^[a-zA-Z0-9_-]+$/.test(code)) {
    errors.code =
      'Code must contain only letters, numbers, hyphens (-), or underscores (_)';
  } else if (/^\d+$/.test(code)) {
    errors.code = 'Code cannot be only numbers';
  } else if (code.length < 5) {
    errors.code = 'Code must be at least 5 characters';
  } else if (code.length > 15) {
    errors.code = 'Code must be at most 15 characters';
  }

  // Description
  if (isEmpty(formData.description)) {
    errors.description = 'Description is required';
  }

  // Optional Text Limits
  if (formData.details && formData.details.length > 500) {
    errors.details = 'Promo Details must be at most 500 characters';
  }

  if (formData.redeem && formData.redeem.length > 500) {
    errors.redeem = 'How to Redeem must be at most 500 characters';
  }

  // Usage Limits
  const usageLimit = formData.countOfUsageLimits;
  if (!isEmpty(usageLimit)) {
    if (!isNumber(usageLimit)) {
      errors.countOfUsageLimits = 'Count of usage limits must be a number';
    } else if (Number(usageLimit) < 0) {
      errors.countOfUsageLimits = 'Count of usage limits cannot be negative';
    }
  }

  // Role 3: Delivery fields
  if (isRole3) {
    if (
      !formData.noOfDelivery ||
      !isNumber(formData.noOfDelivery) ||
      Number(formData.noOfDelivery) < 1
    ) {
      errors.noOfDelivery =
        'No. of Delivery is required and must be at least 1';
    }

    if (
      !formData.deliveryDuration ||
      !isNumber(formData.deliveryDuration) ||
      Number(formData.deliveryDuration) < 1
    ) {
      errors.deliveryDuration =
        'Delivery duration is required and must be at least 1';
    }

    if (isEmpty(formData.deliveryDurationUnit)) {
      errors.deliveryDurationUnit = 'Delivery duration unit is required';
    }
  }

  if (formData?.geolocationBasedPromotions) {
    if (!isNumber(formData?.geolocationBasedPromotions)) {
      errors.geolocationBasedPromotions =
        'Geolocation  code  must  be a number';
    }
  }

  console.log('Validation Errors:', errors);
  return errors;
};
